import { useMemo } from "react";

import { useEntityManagementApiService } from "shared/services";

import type { BackendEntityType } from "../types";

const useEntityManagement = () => {
	const entityManagementService = useEntityManagementApiService();

	const methods = useMemo(() => {
		return {
			getEntityMembers: async <T>({
				entity,
				id,
				limit,
				after
			}: {
				entity: BackendEntityType;
				id: string;
				limit?: number;
				after?: string;
			}) => {
				try {
					return await entityManagementService.getEntityMembers<T>({ entity, id, limit, after });
				} catch (err) {
					console.log(err);
				}
			}
		};
	}, [entityManagementService]);

	return { ...methods };
};

export default useEntityManagement;
